import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import type { CoverageRule } from '@/shared/types';
import { hasCustomCoverageRuleLabels } from '../utils/coverage.util';

const PROPERTY_COVERAGES_QUERY_KEY = 'propertyCoverages';

export const useHasCustomScreeningStatusLabels = (isSmbInvite: boolean) => {
  const queryClient = useQueryClient();

  return useCallback(
    (propertyId?: string | null) => {
      if (isSmbInvite || !propertyId) return false;

      const cachedCoverageRules = queryClient.getQueriesData<CoverageRule[]>({
        queryKey: [PROPERTY_COVERAGES_QUERY_KEY, propertyId],
      });

      return cachedCoverageRules.some(([, rules]) => hasCustomCoverageRuleLabels(rules));
    },
    [isSmbInvite, queryClient],
  );
};
